import React from 'react';
import { ProductsFromProductList } from '../../gql/queries/ProductLists.gql';
import { useQuery } from '@apollo/react-hooks';
import ProductListItem from './ProductListItem';

export default function ProductList({ articleNumbers }) {
  const { data: { products = [] } = {} } = useQuery(ProductsFromProductList, {
    errorPolicy: 'ignore',
    variables: { articleNumbers },
    skip: !articleNumbers?.length
  });

  return products?.length ? (
    <div className="ProductList">
      {products.map(product => (
        <ProductListItem
          as="div"
          key={product.articleNumber}
          product={product}
        />
      ))}
    </div>
  ) : null;
}
